<template>
    <div v-if="getPermission.opcockpiti.view || getPermission.opcockpito.view">

        <md-tabs md-sync-route class="operation-cockpit-tabs">
          <md-tab id="tab-inbound" md-label="Inbound" to="/fsiOperationCockpit/inbound" v-if="getPermission.opcockpiti.view"></md-tab>
          <md-tab id="tab-outbound" md-label="Outbound" to="/fsiOperationCockpit/outbound" v-if="getPermission.opcockpito.view"></md-tab>
          <md-tab id="tab-ocReports" md-label="Reports" to="/fsiOperationCockpit/ocReports" v-if="getPermission.opcockpito.view"></md-tab>
          <md-tab id="tab-outboundList" md-label="OutboundList" to="/fsiOperationCockpit/outboundList" v-if="getPermission.opcockpito.view"></md-tab>
        </md-tabs>
        <router-view/>

    </div>

</template>

<style lang="scss">


  .operation-cockpit-tabs {
    .md-tabs-navigation {
      .md-theme-default {
        height: 30px;
      }
    }
  }
</style>


<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({}),
    computed: {
      ...mapGetters([
        'getPermission',
        'getMasterDataName',
      ]),
    },
  };

</script>



